import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-top-sort",
  "use": "icon-top-sort-usage",
  "viewBox": "0 0 2204 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 2204 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-top-sort\"><defs><style type=\"text/css\"></style></defs><path d=\"M1877.662108 1024L1096.73724 190.674653 320.193684 1024H0.182731l963.888413-1024h268.837241l959.857608 1024h-315.45439z\" p-id=\"3282\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol